import { Card, CardBody, Col } from "reactstrap";
import DefaultPaginationList from "../Common/DefaultPaginationList";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DefaultPaginationTitle } from "../../../../Constants/Constants";
import { DefaultPageData, DefaultPageSubTitle } from "../../../../Data/BonusUi/Pagination";

const DefaultPagination = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={DefaultPaginationTitle} span={DefaultPageSubTitle} />
        <CardBody>
          <DefaultPaginationList pageColor="primary" data={DefaultPageData}/>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DefaultPagination;
